{
  "INBOX_MGMT": {
    "HEADER": "Inboxes",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Search inboxes...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "Your inbox is disconnected. You won't receive new messages until you reauthorize it.",
    "CLICK_TO_RECONNECT": "Click here to reconnect.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "Complete Registration",
    "LIST": {
      "404": "There are no inboxes attached to this account."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Choose Channel",
        "BODY": "Choose the provider you want to integrate with Chatwoot."
      },
      "INBOX": {
        "TITLE": "Create Inbox",
        "BODY": "Authenticate your account and create an inbox."
      },
      "AGENT": {
        "TITLE": "Add Agents",
        "BODY": "Add agents to the created inbox."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "You are all set to go!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Inbox Name",
        "PLACEHOLDER": "Enter your inbox name (eg: Acme Inc)",
        "ERROR": "Please enter a valid inbox name"
      },
      "WEBSITE_NAME": {
        "LABEL": "Website Name",
        "PLACEHOLDER": "Enter your website name (eg: Acme Inc)"
      },
      "FB": {
        "HELP": "PS: By signing in, we only get access to your Page's messages. Your private messages can never be accessed by Chatwoot.",
        "CHOOSE_PAGE": "Choose Page",
        "CHOOSE_PLACEHOLDER": "Select a page from the list",
        "INBOX_NAME": "Inbox Name",
        "ADD_NAME": "Add a name for your inbox",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Pick a value",
        "CREATE_INBOX": "Create Inbox"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continue with Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Connect your Instagram Profile",
        "HELP": "To add your Instagram profile as a channel, you need to authenticate your Instagram Profile by clicking on 'Continue with Instagram' ",
        "ERROR_MESSAGE": "There was an error connecting to Instagram, please try again",
        "ERROR_AUTH": "There was an error connecting to Instagram, please try again",
        "NEW_INBOX_SUGGESTION": "This Instagram account was previously linked to a different inbox and has now been migrated here. All new messages will appear here. The old inbox will no longer be able to send or receive messages for this account.",
        "DUPLICATE_INBOX_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. You won’t be able to send/receive Instagram messages from this inbox anymore."
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Continue with TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Connect your TikTok Profile",
        "HELP": "To add your TikTok profile as a channel, you need to authenticate your TikTok Profile by clicking on 'Continue with TikTok' ",
        "ERROR_MESSAGE": "There was an error connecting to TikTok, please try again",
        "ERROR_AUTH": "There was an error connecting to TikTok, please try again"
      },
      "TWITTER": {
        "HELP": "To add your Twitter profile as a channel, you need to authenticate your Twitter Profile by clicking on 'Sign in with Twitter' ",
        "ERROR_MESSAGE": "There was an error connecting to Twitter, please try again",
        "TWEETS": {
          "ENABLE": "Create conversations from mentioned Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Website channel",
        "DESC": "Create a channel for your website and start supporting your customers via our website widget.",
        "LOADING_MESSAGE": "Creating Website Support Channel",
        "CHANNEL_AVATAR": {
          "LABEL": "Channel Avatar"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Please enter a valid URL"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Website Domain",
          "PLACEHOLDER": "Enter your website domain (eg: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Welcome Heading",
          "PLACEHOLDER": "Hi there !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Welcome Tagline",
          "PLACEHOLDER": "We make it simple to connect with us. Ask us anything, or share your feedback."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Channel greeting message",
          "PLACEHOLDER": "Acme Inc typically replies in a few hours."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Enable channel greeting",
          "HELP_TEXT": "Automatically send a greeting message when a new conversation is created.",
          "ENABLED": "Enabled",
          "DISABLED": "Disabled"
        },
        "REPLY_TIME": {
          "TITLE": "Set Reply time",
          "IN_A_FEW_MINUTES": "In a few minutes",
          "IN_A_FEW_HOURS": "In a few hours",
          "IN_A_DAY": "In a day",
          "HELP_TEXT": "This reply time will be displayed on the live chat widget"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widget Color",
          "PLACEHOLDER": "Update the widget color used in widget"
        },
        "SUBMIT_BUTTON": "Create inbox",
        "API": {
          "ERROR_MESSAGE": "We were not able to create a website channel, please try again"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Channel",
        "DESC": "Integrate Twilio and start supporting your customers via SMS or WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Account SID",
          "PLACEHOLDER": "Please enter your Twilio Account SID",
          "ERROR": "This field is required"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "This field is required"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "This field is required"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "Please enter your Twilio Messaging Service SID",
          "ERROR": "This field is required",
          "USE_MESSAGING_SERVICE": "Use a Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Channel Type",
          "ERROR": "Please select your Channel Type"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "Please enter your Twilio Auth Token",
          "ERROR": "This field is required"
        },
        "CHANNEL_NAME": {
          "LABEL": "Inbox Name",
          "PLACEHOLDER": "Please enter a inbox name",
          "ERROR": "This field is required"
        },
        "PHONE_NUMBER": {
          "LABEL": "Телефон",
          "PLACEHOLDER": "Please enter the phone number from which message will be sent.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the message callback URL in Twilio with the URL mentioned here."
        },
        "SUBMIT_BUTTON": "Create Twilio Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to authenticate Twilio credentials, please try again"
        }
      },
      "SMS": {
        "TITLE": "SMS Channel",
        "DESC": "Start supporting your customers via SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the SMS channel"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Account ID",
            "PLACEHOLDER": "Please enter your Bandwidth Account ID",
            "ERROR": "This field is required"
          },
          "API_KEY": {
            "LABEL": "API Key",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "This field is required"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "This field is required"
          },
          "APPLICATION_ID": {
            "LABEL": "Application ID",
            "PLACEHOLDER": "Please enter your Bandwidth Application ID",
            "ERROR": "This field is required"
          },
          "INBOX_NAME": {
            "LABEL": "Име на входящата кутия",
            "PLACEHOLDER": "Please enter a inbox name",
            "ERROR": "This field is required"
          },
          "PHONE_NUMBER": {
            "LABEL": "Телефон",
            "PLACEHOLDER": "Please enter the phone number from which message will be sent.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Create Bandwidth Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to authenticate Bandwidth credentials, please try again"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "You have to configure the message callback URL in Bandwidth with the URL mentioned here."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "WhatsApp Channel",
        "DESC": "Start supporting your customers via WhatsApp.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "WhatsApp Cloud",
          "WHATSAPP_CLOUD_DESC": "Quick setup through Meta",
          "TWILIO_DESC": "Connect via Twilio credentials",
          "360_DIALOG": "360Dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "Select your API provider",
          "DESCRIPTION": "Choose your WhatsApp provider. You can connect directly through Meta which requires no setup, or connect through Twilio using your account credentials."
        },
        "INBOX_NAME": {
          "LABEL": "Inbox Name",
          "PLACEHOLDER": "Please enter an inbox name",
          "ERROR": "This field is required"
        },
        "PHONE_NUMBER": {
          "LABEL": "Телефон",
          "PLACEHOLDER": "Please enter the phone number from which message will be sent.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "Phone number ID",
          "PLACEHOLDER": "Please enter the Phone number ID obtained from Facebook developer dashboard.",
          "ERROR": "Please enter a valid value."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "Business Account ID",
          "PLACEHOLDER": "Please enter the Business Account ID obtained from Facebook developer dashboard.",
          "ERROR": "Please enter a valid value."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Webhook Verify Token",
          "PLACEHOLDER": "Enter a verify token which you want to configure for Facebook webhooks.",
          "ERROR": "Please enter a valid value."
        },
        "API_KEY": {
          "LABEL": "API key",
          "SUBTITLE": "Configure the WhatsApp API key.",
          "PLACEHOLDER": "API key",
          "ERROR": "Please enter a valid value."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "SUBMIT_BUTTON": "Create WhatsApp Channel",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Quick setup with Meta",
          "DESC": "Use the WhatsApp Embedded Signup flow to quickly connect new numbers. You will be redirected to Meta to log into your WhatsApp Business account. Having admin access will help make the setup smooth and easy.",
          "BENEFITS": {
            "TITLE": "Benefits of Embedded Signup:",
            "EASY_SETUP": "No manual configuration required",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Automatic webhook and phone number configuration"
          },
          "LEARN_MORE": {
            "TEXT": "To learn more about integrated signup, pricing, and limitations, visit {link}.",
            "LINK_TEXT": "this link"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Authenticating with Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Setting up your WhatsApp Business Account",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Loading Facebook SDK...",
          "CANCELLED": "WhatsApp Signup was cancelled",
          "SUCCESS_TITLE": "WhatsApp Business Account Connected!",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Invalid business data received from Facebook. Please try again.",
          "SIGNUP_ERROR": "Signup error occurred",
          "AUTH_NOT_COMPLETED": "Authentication not completed. Please restart the process.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account has been successfully configured",
          "MANUAL_FALLBACK": "If your number is already connected to the WhatsApp Business Platform (API), or if you’re a tech provider onboarding your own number, please use the {link} flow",
          "MANUAL_LINK_TEXT": "manual setup flow",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the WhatsApp channel"
        }
      },
      "VOICE": {
        "TITLE": "Voice Channel",
        "DESC": "Integrate Twilio Voice and start supporting your customers via phone calls.",
        "PHONE_NUMBER": {
          "LABEL": "Phone Number",
          "PLACEHOLDER": "Enter your phone number (e.g. +1234567890)",
          "ERROR": "Please provide a valid phone number in E.164 format (e.g. +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "Account SID",
            "PLACEHOLDER": "Enter your Twilio Account SID",
            "REQUIRED": "Account SID is required"
          },
          "AUTH_TOKEN": {
            "LABEL": "Auth Token",
            "PLACEHOLDER": "Enter your Twilio Auth Token",
            "REQUIRED": "Auth Token is required"
          },
          "API_KEY_SID": {
            "LABEL": "API Key SID",
            "PLACEHOLDER": "Enter your Twilio API Key SID",
            "REQUIRED": "API Key SID is required"
          },
          "API_KEY_SECRET": {
            "LABEL": "API Key Secret",
            "PLACEHOLDER": "Enter your Twilio API Key Secret",
            "REQUIRED": "API Key Secret is required"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Configure this URL as the Voice URL on your Twilio phone number and TwiML App.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "Configure this URL as the Status Callback URL on your Twilio phone number."
        },
        "SUBMIT_BUTTON": "Create Voice Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the voice channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API Channel",
        "DESC": "Integrate with API channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Create API Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the api channel"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Email Channel",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "Email where your customers sends you support tickets",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "Create Email Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the email channel"
        },
        "FINISH_MESSAGE": "Start forwarding your emails to the following email address.",
        "FINISH_MESSAGE_NO_FORWARDING": "Your email inbox has been created successfully! You need to configure SMTP and IMAP credentials to send and receive emails. Without these settings, no emails will be processed.",
        "FORWARDING_ADDRESS_LABEL": "Forward emails to this address:",
        "CONFIGURE_SMTP_IMAP_LINK": "Click here",
        "CONFIGURE_SMTP_IMAP_TEXT": " to configure IMAP and SMTP settings"
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Channel",
        "DESC": "Integrate with LINE channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Channel ID",
          "PLACEHOLDER": "LINE Channel ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Channel Secret",
          "PLACEHOLDER": "LINE Channel Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Channel Token",
          "PLACEHOLDER": "LINE Channel Token"
        },
        "SUBMIT_BUTTON": "Create LINE Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the LINE channel"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the webhook URL in LINE application with the URL mentioned here."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Channel",
        "DESC": "Integrate with Telegram channel and start supporting your customers.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Configure the bot token you have obtained from Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Create Telegram Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the telegram channel"
        }
      },
      "AUTH": {
        "TITLE": "Choose a channel",
        "DESC": "Chatwoot supports live-chat widgets, Facebook Messenger, Twitter profiles, WhatsApp, Emails, etc., as channels. If you want to build a custom channel, you can create it using the API channel. To get started, choose one of the channels below.",
        "TITLE_NEXT": "Complete the setup",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "Website",
            "DESCRIPTION": "Create a live-chat widget"
          },
          "FACEBOOK": {
            "TITLE": "Facebook",
            "DESCRIPTION": "Connect your Facebook page"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "Support your customers on WhatsApp"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "Email",
            "DESCRIPTION": "Connect with Gmail, Outlook, or other providers"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Integrate SMS channel with Twilio or bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "Make a custom channel using our API"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "Configure Telegram channel using Bot token"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Integrate your Line channel"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Connect your instagram account"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Connect your TikTok account"
          },
          "VOICE": {
            "TITLE": "Voice",
            "DESCRIPTION": "Integrate with Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "Агенти",
        "DESC": "Here you can add agents to manage your newly created inbox. Only these selected agents will have access to your inbox. Agents which are not part of this inbox will not be able to see or respond to messages in this inbox when they login. <br> <b>PS:</b> As an administrator, if you need access to all inboxes, you should add yourself as agent to all inboxes that you create.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Pick agents for the inbox"
      },
      "DETAILS": {
        "TITLE": "Inbox Details",
        "DESC": "From the dropdown below, select the Facebook Page you want to connect to Chatwoot. You can also give a custom name to your inbox for better identification."
      },
      "FINISH": {
        "TITLE": "Nailed It!",
        "DESC": "You have successfully finished integrating your Facebook Page with Chatwoot. Next time a customer messages your Page, the conversation will automatically appear on your inbox.<br>We are also providing you with a widget script that you can easily add to your website. Once this is live on your website, customers can message you right from your website without the help of any external tool and the conversation will appear right here, on Chatwoot.<br>Cool, huh? Well, we sure try to be :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Authenticating you with Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Something went wrong, Please refresh page...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "CREATING_CHANNEL": "Creating your Inbox...",
      "TITLE": "Configure Inbox Details",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Add agents",
      "ADD_AGENTS": "Adding Agents to your Inbox..."
    },
    "FINISH": {
      "TITLE": "Your Inbox is ready!",
      "MESSAGE": "You can now engage with your customers through your new Channel. Happy supporting",
      "BUTTON_TEXT": "Take me there",
      "MORE_SETTINGS": "More settings",
      "WEBSITE_SUCCESS": "You have successfully finished creating a website channel. Copy the code shown below and paste it on your website. Next time a customer use the live chat, the conversation will automatically appear on your inbox.",
      "WHATSAPP_QR_INSTRUCTION": "Scan the QR code above to quickly test your WhatsApp inbox",
      "MESSENGER_QR_INSTRUCTION": "Scan the QR code above to quickly test your Facebook Messenger inbox",
      "TELEGRAM_QR_INSTRUCTION": "Scan the QR code above to quickly test your Telegram inbox"
    },
    "REAUTH": "Reauthorize",
    "VIEW": "View",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Inbox settings updated successfully",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Auto assignment updated successfully",
        "ERROR_MESSAGE": "We couldn't update inbox settings. Please try again later."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "от",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Включен",
        "DISABLED": "Изключен"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Включен",
        "DISABLED": "Изключен"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "Enable"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Изтрий",
      "AVATAR_DELETE_BUTTON_TEXT": "Delete Avatar",
      "CONFIRM": {
        "TITLE": "Потвърди изтриването",
        "MESSAGE": "Сигурни ли сте за изтриването ",
        "PLACE_HOLDER": "Please type {inboxName} to confirm",
        "YES": "Да, изтрий ",
        "NO": "Не, запази "
      },
      "API": {
        "SUCCESS_MESSAGE": "Inbox deleted successfully",
        "ERROR_MESSAGE": "Could not delete inbox. Please try again later.",
        "AVATAR_SUCCESS_MESSAGE": "Inbox avatar deleted successfully",
        "AVATAR_ERROR_MESSAGE": "Could not delete the inbox avatar. Please try again later."
      }
    },
    "TABS": {
      "SETTINGS": "Settings",
      "COLLABORATORS": "Collaborators",
      "CONFIGURATION": "Configuration",
      "CAMPAIGN": "Campaigns",
      "PRE_CHAT_FORM": "Pre Chat Form",
      "BUSINESS_HOURS": "Business Hours",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Bot Configuration",
      "ACCOUNT_HEALTH": "Account Health",
      "CSAT": "CSAT",
      "VOICE": "Voice",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "Manage your WhatsApp account",
      "DESCRIPTION": "Review your WhatsApp account status, messaging limits, and quality. Update settings or resolve issues if needed",
      "GO_TO_SETTINGS": "Go to Meta Business Manager",
      "NO_DATA": "Health data is not available",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Display phone number",
          "TOOLTIP": "Phone number displayed to customers"
        },
        "VERIFIED_NAME": {
          "LABEL": "Business name",
          "TOOLTIP": "Business name verified by WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Display name status",
          "TOOLTIP": "Status of your business name verification"
        },
        "QUALITY_RATING": {
          "LABEL": "Quality rating",
          "TOOLTIP": "WhatsApp quality rating for your account"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Messaging limit tier",
          "TOOLTIP": "Daily messaging limit for your account"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Account mode",
          "TOOLTIP": "Current operating mode of your WhatsApp account"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 customers per 24h",
          "TIER_1000": "1K customers per 24h",
          "TIER_1K": "1K customers per 24h",
          "TIER_10K": "10K customers per 24h",
          "TIER_100K": "100K customers per 24h",
          "TIER_UNLIMITED": "Unlimited customers per 24h",
          "UNKNOWN": "Rating not available"
        },
        "STATUSES": {
          "APPROVED": "Approved",
          "PENDING_REVIEW": "Pending Review",
          "AVAILABLE_WITHOUT_REVIEW": "Available Without Review",
          "REJECTED": "Rejected",
          "DECLINED": "Declined",
          "NON_EXISTS": "Non exists"
        },
        "MODES": {
          "SANDBOX": "Sandbox",
          "LIVE": "Live"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "Settings",
    "FEATURES": {
      "LABEL": "Features",
      "DISPLAY_FILE_PICKER": "Display file picker on the widget",
      "DISPLAY_EMOJI_PICKER": "Display emoji picker on the widget",
      "ALLOW_END_CONVERSATION": "Allow users to end conversation from the widget",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Script",
      "MESSENGER_SUB_HEAD": "Place this button inside your body tag",
      "ALLOWED_DOMAINS": {
        "TITLE": "Allowed Domains",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "Secret Key",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "Агенти",
      "INBOX_AGENTS_SUB_TEXT": "Add or remove agents from this inbox",
      "AGENT_ASSIGNMENT": "Conversation Assignment",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Update conversation assignment settings",
      "UPDATE": "Update",
      "ENABLE_EMAIL_COLLECT_BOX": "Enable email collect box",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Enable or disable email collect box on new conversation",
      "AUTO_ASSIGNMENT": "Enable auto assignment",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Enable conversation continuity via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversations will continue over email if the contact email address is available.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "Inbox Settings",
      "INBOX_UPDATE_SUB_TEXT": "Update your inbox settings",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Enable or disable the automatic assignment of new conversations to the agents added to this inbox.",
      "HMAC_VERIFICATION": "User Identity Validation",
      "HMAC_DESCRIPTION": "In order to validate the user's identity, you can pass an `identifier_hash` for each user. You can generate a HMAC sha256 hash using the `identifier` with the key shown here.",
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Enforce User Identity Validation",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "INBOX_IDENTIFIER": "Inbox Identifier",
      "INBOX_IDENTIFIER_SUB_TEXT": "Use the `inbox_identifier` token shown here to authentication your API clients.",
      "FORWARD_EMAIL_TITLE": "Forward to Email",
      "FORWARD_EMAIL_SUB_TEXT": "Start forwarding your emails to the following email address.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Forwarding emails to your inbox is currently disabled on this installation. To use this feature, it must be enabled by your administrator. Please get in touch with them to proceed.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Allow messages after conversation resolved",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Allow the end-users to send messages even after the conversation is resolved.",
      "WHATSAPP_SECTION_SUBHEADER": "This API Key is used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Enter the new API key to be used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_TITLE": "API Key",
      "WHATSAPP_SECTION_UPDATE_TITLE": "Update API Key",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Enter the new API Key here",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "Обновяване",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "This inbox is connected through WhatsApp embedded signup.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "You can reconfigure this inbox to update your WhatsApp Business settings.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Reconfigure",
      "WHATSAPP_CONNECT_TITLE": "Connect to WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "Upgrade to WhatsApp embedded signup for easier management.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Connect this inbox to WhatsApp Business for enhanced features and easier management.",
      "WHATSAPP_CONNECT_BUTTON": "Connect",
      "WHATSAPP_CONNECT_SUCCESS": "Successfully connected to WhatsApp Business!",
      "WHATSAPP_CONNECT_ERROR": "Failed to connect to WhatsApp Business. Please try again.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "Successfully reconfigured WhatsApp Business!",
      "WHATSAPP_RECONFIGURE_ERROR": "Failed to reconfigure WhatsApp Business. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp login was cancelled. Please try again.",
      "WHATSAPP_WEBHOOK_TITLE": "Webhook Verification Token",
      "WHATSAPP_WEBHOOK_SUBHEADER": "This token is used to verify the authenticity of the webhook endpoint.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "Manually sync message templates from WhatsApp to update your available templates.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Templates sync initiated successfully. It may take a couple of minutes to update.",
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings"
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "NONE": "None",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Auto assignment limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Please enter a value greater than 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limit the maximum number of conversations from this inbox that can be auto assigned to an agent"
    },
    "ASSIGNMENT": {
      "TITLE": "Conversation Assignment",
      "DESCRIPTION": "Automatically assign incoming conversations to available agents based on assignment policies",
      "ENABLE_AUTO_ASSIGNMENT": "Enable automatic conversation assignment",
      "DEFAULT_RULES_TITLE": "Default assignment rules",
      "DEFAULT_RULES_DESCRIPTION": "Using the default assignment behavior for all conversations",
      "DEFAULT_RULE_1": "Earliest created conversations first",
      "DEFAULT_RULE_2": "Round robin distribution",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Using custom assignment policy for this inbox",
      "CUSTOMIZE_POLICY": "Customize with assignment policy",
      "DELETE_POLICY": "Delete policy",
      "POLICY_LABEL": "Assignment policy",
      "ASSIGNMENT_ORDER_LABEL": "Assignment Order",
      "ASSIGNMENT_METHOD_LABEL": "Assignment Method",
      "POLICY_STATUS": {
        "ACTIVE": "Активен",
        "INACTIVE": "Inactive"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "Earliest created",
        "LONGEST_WAITING": "Longest waiting"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin",
        "BALANCED": "Balanced assignment"
      },
      "UPGRADE_PROMPT": "Custom assignment policies are available on the Business plan",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Default policy linked",
      "DEFAULT_POLICY_DESCRIPTION": "Link a custom assignment policy to customize how conversations are assigned to agents in this inbox.",
      "LINK_EXISTING_POLICY": "Link existing policy",
      "CREATE_NEW_POLICY": "Create new policy",
      "NO_POLICIES": "No assignment policies found",
      "VIEW_ALL_POLICIES": "View all policies",
      "CURRENT_BEHAVIOR": "Currently using default assignment behavior:",
      "LINK_SUCCESS": "Assignment policy linked successfully",
      "LINK_ERROR": "Failed to link assignment policy"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Delete assignment policy?",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to remove this assignment policy from this inbox? The inbox will revert to default assignment rules.",
      "CANCEL": "Отмени",
      "CONFIRM_DELETE": "Изтрий",
      "DELETE_SUCCESS": "Assignment policy removed successfully",
      "DELETE_ERROR": "Failed to remove assignment policy"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Reauthorize",
      "SUBTITLE": "Your Facebook connection has expired, please reconnect your Facebook page to continue services",
      "MESSAGE_SUCCESS": "Reconnection successful",
      "MESSAGE_ERROR": "There was an error, please try again"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Pre chat forms enable you to capture user information before they start conversation with you.",
      "SET_FIELDS": "Pre chat form fields",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Fields",
        "LABEL": "Label",
        "PLACE_HOLDER": "Placeholder",
        "KEY": "Ключ",
        "TYPE": "Тип",
        "REQUIRED": "Required"
      },
      "ENABLE": {
        "LABEL": "Enable pre chat form",
        "OPTIONS": {
          "ENABLED": "Yes",
          "DISABLED": "No"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre chat message",
        "PLACEHOLDER": "This message would be visible to the users along with the form"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Visitors should provide their name and email address before starting the chat"
      }
    },
    "CSAT": {
      "TITLE": "Enable CSAT",
      "SUBTITLE": "Automatically trigger CSAT surveys at the end of conversations to understand how customers feel about their support experience. Track satisfaction trends and identify areas for improvement over time.",
      "DISPLAY_TYPE": {
        "LABEL": "Display type"
      },
      "MESSAGE": {
        "LABEL": "Съобщение",
        "PLACEHOLDER": "Please enter a message to show users with the form"
      },
      "BUTTON_TEXT": {
        "LABEL": "Button text",
        "PLACEHOLDER": "Please rate us"
      },
      "LANGUAGE": {
        "LABEL": "Language",
        "PLACEHOLDER": "Select template language"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Message preview",
        "TOOLTIP": "This may vary slightly when rendered on WhatsApp's platform."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "Approved by WhatsApp",
        "PENDING": "Pending WhatsApp approval",
        "REJECTED": "Meta rejected the template",
        "DEFAULT": "Needs WhatsApp approval",
        "NOT_FOUND": "The template does not exist in the Meta platform."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp template created successfully and sent for approval",
        "ERROR_MESSAGE": "Failed to create WhatsApp template"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Edit survey details",
        "DESCRIPTION": "We will delete the previous template and make a new one which will be sent again for WhatsApp approval",
        "CONFIRM": "Create new template",
        "CANCEL": "Go back"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Survey rule",
        "DESCRIPTION_PREFIX": "Send the survey if the conversation",
        "DESCRIPTION_SUFFIX": "any of the labels",
        "OPERATOR": {
          "CONTAINS": "съдържа",
          "DOES_NOT_CONTAINS": "не съдържа"
        },
        "SELECT_PLACEHOLDER": "select labels"
      },
      "NOTE": "Note: CSAT surveys are sent only once per conversation",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT settings updated successfully",
        "ERROR_MESSAGE": "We couldn't update CSAT settings. Please try again later."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Set your availability",
      "SUBTITLE": "Set your availability on your livechat widget",
      "WEEKLY_TITLE": "Set your weekly hours",
      "TIMEZONE_LABEL": "Select timezone",
      "UPDATE": "Update business hours settings",
      "TOGGLE_AVAILABILITY": "Enable business availability for this inbox",
      "UNAVAILABLE_MESSAGE_LABEL": "Unavailable message for visitors",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "DAY": "Day",
        "AVAILABILITY": "Availability",
        "HOURS": "Hours",
        "ENABLE": "Enable availability for this day",
        "UNAVAILABLE": "Unavailable",
        "VALIDATION_ERROR": "Starting time should be before closing time.",
        "CHOOSE": "Choose"
      },
      "ALL_DAY": "All-Day"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Set your IMAP details",
      "NOTE_TEXT": "To enable SMTP, please configure IMAP.",
      "UPDATE": "Update IMAP settings",
      "TOGGLE_AVAILABILITY": "Enable IMAP configuration for this inbox",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update IMAP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Login",
        "PLACE_HOLDER": "Login"
      },
      "PASSWORD": {
        "LABEL": "Password",
        "PLACE_HOLDER": "Password"
      },
      "ENABLE_SSL": "Enable SSL",
      "AUTH_MECHANISM": "Authentication"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Set your SMTP details",
      "UPDATE": "Update SMTP settings",
      "TOGGLE_AVAILABILITY": "Enable SMTP configuration for this inbox",
      "TOGGLE_HELP": "Enabling SMTP will help the user to send email",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update SMTP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Login",
        "PLACE_HOLDER": "Login"
      },
      "PASSWORD": {
        "LABEL": "Password",
        "PLACE_HOLDER": "Password"
      },
      "DOMAIN": {
        "LABEL": "Domain",
        "PLACE_HOLDER": "Domain"
      },
      "ENCRYPTION": "Encryption",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Verify Mode",
      "AUTH_MECHANISM": "Authentication"
    },
    "NOTE": "Note: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar deleted successfully",
              "ERROR_MESSAGE": "Възникна грешка, моля опитайте отново"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Website Name",
          "PLACE_HOLDER": "Enter your website name (eg: Acme Inc)",
          "ERROR": "Please enter a valid website name"
        },
        "WELCOME_HEADING": {
          "LABEL": "Welcome Heading",
          "PLACE_HOLDER": "Hi there!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Welcome Tagline",
          "PLACE_HOLDER": "We make it simple to connect with us. Ask us anything, or share your feedback."
        },
        "REPLY_TIME": {
          "LABEL": "Reply Time",
          "IN_A_FEW_MINUTES": "In a few minutes",
          "IN_A_FEW_HOURS": "In a few hours",
          "IN_A_DAY": "In a day"
        },
        "WIDGET_COLOR_LABEL": "Widget Color",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "Тип:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Чатете с нас",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "Чатете с нас"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Update Widget Settings",
          "API": {
            "SUCCESS_MESSAGE": "Widget settings updated successfully",
            "ERROR_MESSAGE": "Unable to update widget settings"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Preview",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Left",
          "RIGHT": "Right"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Expanded Bubble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Default",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Обикновено отговаряме до няколко минути",
        "IN_A_FEW_HOURS": "Обикновено отговаряме до няколко часа",
        "IN_A_DAY": "Обикновено отговаряме до един ден"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Започнете разговор",
        "CHAT_INPUT_PLACEHOLDER": "Напишете вашето съобщение"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "We are Online",
          "OFFLINE": "В момента не сме на линия"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hello"
      },
      "BRANDING_TEXT": "Осъществено от Chatwoot",
      "SCRIPT_SETTINGS": "\n      window.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Connect with Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Connect with Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Other Providers",
        "DESCRIPTION": "Connect with Other Providers"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Website",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "Имейл",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API Channel",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Voice"
    }
  }
}
